import { TextField } from "@mui/material";
import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextL, TextM, TextMS } from "../../common/text";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
`;

export const RegisterHeader = styled.div`
  width: 80%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RegisterWrapper = styled.div`
  width: 80%;
  height: 20%; // 최하단에 overflow로 인해 안보이는 현상 해결 20230215 김찬우
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
  gap: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 50px;
  }
`;

export const RegisterEmailInput = styled(TextField)`
  width: 95%;
  height: 25px;
  // 크롬 아이디 자동완성시 기본 배경색 제거
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  .MuiInputBase-input {
    font-size: 16px;
    font-family: "Bold";
    text-align: center;
  }
  label.Mui-focused {
    color: #f44b59;
  }
  .MuiInput-underline:after {
    border-bottom-color: #f44b59;
  }
  .MuiFormHelperText-root {
    color: #f44b59;
    text-align: center;
  }
  @media ${({ theme }) => theme.device.tablet} {
    width: 80%;
    height: 45px;
    .MuiInputBase-input {
      font-size: 25px;
      font-family: "Bold";
      text-align: center;
    }
    .MuiFormHelperText-root {
      font-size: 18px;
    }
  }
`;

export const NextButton = styled.div`
  width: 75%;
  height: 50px;
  background-color: ${({ isValidEmail }) =>
    isValidEmail ? "#f44b59" : "#eaeaea"};

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 65%;
    height: 60px;
  }
`;

export const NextButtonText = styled(TextM)`
  color : ${({ isValidEmail }) => (isValidEmail ? "#FFF" : "#9F9F9F")}}

`;
